import { IFormFieldKey } from '../../../../interfaces/Form';
import { formFieldKeysToValidations } from '../../../../validations/Form';
import { formFieldKeysToExclusions } from '../../../../validations/Interfield';
import LazyComponentLoader from '../../../components/LazyComponentLoader';
import { FieldBooleanChatComponent } from '../../fieldBoolean/types';
import { FieldDescriptionChatComponent } from '../../fieldDescription/types';
import { FieldDesignQuantitiesChatComponent } from '../../fieldDesignQuantities/types';
import { FieldDimensionChatComponent } from '../../fieldDimension/types';
import { FieldMaterialChatComponent } from '../../fieldMaterial/types';
import { FieldMultiSelectorChatComponent } from '../../fieldMultiSelector/types';
import { FieldOptionalDimensionChatComponent } from '../../fieldOptionalDimension/types';
import { FieldOptionalMaterialChatComponent } from '../../fieldOptionalMaterial/types';
import { FieldOptionalMaterialCompositeChatComponent } from '../../fieldOptionalMaterialComposite/types';
import { FieldOptionalShapeDimensionChatComponent } from '../../fieldOptionalShapeDimension/types';
import { FieldShapeChatComponent } from '../../fieldShape/types';
import { FieldShapeDimensionChatComponent } from '../../fieldShapeDimension/types';
import { FieldShapeQuantitiesChatComponent } from '../../fieldShapeQuantities/types';
import { FieldRadioListChatComponent } from '../../fieldRadioList/types';
import { FieldOptionalShapeMaterialChatComponent } from '../../fieldOptionalShapeMaterial/types';
import { FieldShapePortfolioDataBasicComponent } from '../../fieldPortfolioData/types';
import { FieldOptionalRadioListChatComponent } from '../../fieldOptionalRadioList/types';

const FieldRadioListChat = LazyComponentLoader({ loader: () => import('../../fieldRadioList/Chat' /* webpackChunkName: "FieldRadioListChat" */) }) as FieldRadioListChatComponent;
const FieldOptionalRadioListChat = LazyComponentLoader({ loader: () => import('../../fieldOptionalRadioList/Chat' /* webpackChunkName: "FieldOptionalRadioListChat" */) }) as FieldOptionalRadioListChatComponent;
const FieldDescriptionChat = LazyComponentLoader({ loader: () => import('../../fieldDescription/Chat' /* webpackChunkName: "FieldDescriptionChat" */) }) as FieldDescriptionChatComponent;
const FieldMaterialChat = LazyComponentLoader({ loader: () => import('../../fieldMaterial/Chat' /* webpackChunkName: "FieldMaterialChat" */) }) as FieldMaterialChatComponent;
const FieldShapeDimensionChat = LazyComponentLoader({ loader: () => import('../../fieldShapeDimension/Chat' /* webpackChunkName: "FieldShapeDimensionChat" */) }) as FieldShapeDimensionChatComponent;
const FieldShapeChat = LazyComponentLoader({ loader: () => import('../../fieldShape/Chat' /* webpackChunkName: "FieldShapeChat" */) }) as FieldShapeChatComponent;
const FieldDimensionChat = LazyComponentLoader({ loader: () => import('../../fieldDimension/Chat' /* webpackChunkName: "FieldDimensionChat" */) }) as FieldDimensionChatComponent;
const FieldOptionalDimensionChat = LazyComponentLoader({ loader: () => import('../../fieldOptionalDimension/Chat' /* webpackChunkName: "FieldOptionalDimensionChat" */) }) as FieldOptionalDimensionChatComponent;
const FieldShapeQuantitiesChat = LazyComponentLoader({ loader: () => import('../../fieldShapeQuantities/Chat' /* webpackChunkName: "FieldShapeQuantitiesChat" */) }) as FieldShapeQuantitiesChatComponent;
const FieldDesignQuantitiesChat = LazyComponentLoader({ loader: () => import('../../fieldDesignQuantities/Chat' /* webpackChunkName: "FieldDesignQuantitiesChat" */) }) as FieldDesignQuantitiesChatComponent;
const FieldOptionalShapeDimensionChat = LazyComponentLoader({ loader: () => import('../../fieldOptionalShapeDimension/Chat' /* webpackChunkName: "FieldOptionalShapeDimensionChat" */) }) as FieldOptionalShapeDimensionChatComponent;
const FieldBooleanChat = LazyComponentLoader({ loader: () => import('../../fieldBoolean/Chat' /* webpackChunkName: "FieldBooleanChat" */) }) as FieldBooleanChatComponent;
const FieldOptionalMaterialChat = LazyComponentLoader({ loader: () => import('../../fieldOptionalMaterial/Chat' /* webpackChunkName: "FieldOptionalMaterialChat" */) }) as FieldOptionalMaterialChatComponent;
const FieldOptionalMaterialCompositeChat = LazyComponentLoader({ loader: () => import('../../fieldOptionalMaterialComposite/Chat' /* webpackChunkName: "FieldOptionalMaterialCompositeChat" */) }) as FieldOptionalMaterialCompositeChatComponent;
const FieldCommentChat = LazyComponentLoader({ loader: () => import('../../fieldComment' /* webpackChunkName: "FieldCommentChat" */) });
const FieldAdditionalDataChat = LazyComponentLoader({ loader: () => import('../../fieldAdditionalData/Chat' /* webpackChunkName: "FieldAdditionalDataChat" */) });
const FieldContactChat = LazyComponentLoader({ loader: () => import('../../fieldContact/Chat' /* webpackChunkName: "FieldContactChat" */) });
const FieldProjectInformationChat = LazyComponentLoader({ loader: () => import('../../fieldProjectInformation/Chat' /* webpackChunkName: "FieldProjectInformationChat" */) });
const FieldUploadFilesChat = LazyComponentLoader({ loader: () => import('../../fieldUploadFiles' /* webpackChunkName: "FieldUploadFilesChat" */) });
const FieldBudgetChat = LazyComponentLoader({ loader: () => import('../../fieldBudgetRange/Chat' /* webpackChunkName: "FieldBudgetRangeChat" */) });
const FieldApplianceLevelChat = LazyComponentLoader({ loader: () => import('../../fieldApllianceLevel/Chat' /* webpackChunkName: "FieldApllianceLevelChat" */) });
const FieldMultiSelectorChat = LazyComponentLoader({ loader: () => import('../../fieldMultiSelector/Chat' /* webpackChunkName: "FieldMultiSelectorChat" */) }) as FieldMultiSelectorChatComponent;
const FieldPortfolioDataBasic = LazyComponentLoader({ loader: () => import('../../fieldPortfolioData/Basic' /* webpackChunkName: "FieldPortfolioDataBasic" */) }) as FieldShapePortfolioDataBasicComponent;
const FieldOptionalShapeMaterialChat = LazyComponentLoader({ loader: () => import('../../fieldOptionalShapeMaterial/Chat' /* webpackChunkName: "FieldOptionalShapeMaterialChat" */) }) as FieldOptionalShapeMaterialChatComponent;

const config = {
    [IFormFieldKey.Description]: {
        fieldComponent        : FieldDescriptionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Description],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.TrayMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TrayMaterial],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.TrayMaterial],
    },
    [IFormFieldKey.Material]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Material],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.Material],
    },
    [IFormFieldKey.WindowMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FrameMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FrameMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarShelfMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarShelfMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.TrayShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TrayShapeDimension],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.TrayShapeDimension],
    },
    [IFormFieldKey.ShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ShapeDimension],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.ShapeDimension],
    },
    [IFormFieldKey.TrayShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TrayShape],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.TrayShape],
    },
    [IFormFieldKey.Shape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Shape],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.Shape],
    },
    [IFormFieldKey.TrayDimension]: {
        fieldComponent        : FieldDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TrayDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarSquareMeter]: {
        fieldComponent        : FieldOptionalDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarSquareMeter],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarDegrees]: {
        fieldComponent        : FieldOptionalDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarDegrees],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarHumidity]: {
        fieldComponent        : FieldOptionalDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarHumidity],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Border]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Border],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.Border],
    },
    [IFormFieldKey.Connectics]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Connectics],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Openings]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Openings],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.AddOns]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.AddOns],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Obstacles]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Obstacles],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Cutting]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Cutting],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.DesignProject]: {
        fieldComponent        : FieldDesignQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.DesignProject],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Extension]: {
        fieldComponent        : FieldOptionalShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Extension],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.Extension],
    },
    [IFormFieldKey.Background]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Background],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarLightingExpose]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarLightingExpose],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.DeckBoardShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.DeckBoardShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.LimonShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.LimonShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PlainSteps]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PlainSteps],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StepsDimension]: {
        fieldComponent        : FieldDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StepsDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StaircaseProtection]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StaircaseProtection],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StaircaseLayingStairs]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StaircaseLayingStairs],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StaircaseRailing]: {
        fieldComponent        : FieldOptionalMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StaircaseRailing],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StaircaseGuard]: {
        fieldComponent        : FieldOptionalMaterialCompositeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StaircaseGuard],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StaircaseLanding]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StaircaseLanding],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.StaircaseSideTurn]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.StaircaseSideTurn],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.TerraceLaying]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TerraceLaying],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.TerraceLight]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TerraceLight],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.TerracePedestals]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TerraceLight],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarPose]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarPose],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarDoor]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarDoor],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarRoom]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarRoom],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarNbDoor]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarNbDoor],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarSensDoor]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarSensDoor],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarShelf]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarShelf],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WineCellarNbBottle]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WineCellarNbBottle],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.LegsMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.LegsMaterial],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.LegsMaterial],
    },
    [IFormFieldKey.LegsShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.LegsShape],
        fieldExclusionsGetter : formFieldKeysToExclusions[IFormFieldKey.LegsShape],
    },
    [IFormFieldKey.GlassWallStyle]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.GlassWallStyle],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClosingType]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClosingType],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.LegsDimension]: {
        fieldComponent        : FieldDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.LegsDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Dimension]: {
        fieldComponent        : FieldDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Dimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Comment]: {
        fieldComponent        : FieldCommentChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Comment],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.AdditionalData]: {
        fieldComponent        : FieldAdditionalDataChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.AdditionalData],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Contact]: {
        fieldComponent        : FieldContactChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Contact],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.MultiSelector]: {
        fieldComponent        : FieldMultiSelectorChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.MultiSelector],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Constraints]: {
        fieldComponent        : FieldMultiSelectorChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Constraints],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.DeckBoardWidth]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.DeckBoardWidth],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortfolioData]: {
        fieldComponent        : FieldPortfolioDataBasic,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortfolioData],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.HighWindDestination]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.HighWindDestination],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.HighWindLaying]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.HighWindLaying],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceDestination]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceDestination],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FencePoles]: {
        fieldComponent        : FieldOptionalShapeMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FencePoles],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceRailing]: {
        fieldComponent        : FieldOptionalMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceRailing],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceFilling]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceFilling],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceProtection]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceProtection],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceMaterial]: {
        fieldComponent        : FieldMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceSecondMaterial]: {
        fieldComponent        : FieldOptionalMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceSecondMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PergolaShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PergolaShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PergolaRoof]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PergolaRoof],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PergolaOptions]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PergolaOptions],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowLeaf]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowLeaf],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowOpening]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowOpening],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowGlazing]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowGlazing],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowInsulation]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowInsulation],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowInstallation]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowInstallation],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.GarageDoorOpening]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.GarageDoorOpening],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.GarageDoorGroove]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.GarageDoorGroove],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.GarageDoorGate]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.GarageDoorGate],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.GarageDoorOptions]: {
        fieldComponent        : FieldMultiSelectorChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.GarageDoorOptions],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClaustraDestination]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClaustraDestination],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClaustraMobility]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClaustraMobility],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClaustraType]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClaustraType],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClaustraLaying]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClaustraLaying],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Quantity]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Quantity],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ShoesQuantity]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Quantity],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.SecondMaterial]: {
        fieldComponent : FieldOptionalMaterialChat,
        fieldValidate  : formFieldKeysToValidations[IFormFieldKey.SecondMaterial],
    },
    [IFormFieldKey.GroundShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.GroundShapeDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.RoofShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.RoofShapeDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.DestinationShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.DestinationShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Vegetals]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Vegetals],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Type]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Type],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.BedShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.BedShapeDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.TopBedShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.TopBedShapeDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FrameShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FrameShapeDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsStyle]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsStyle],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsFilling]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsFilling],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsFunction]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsFunction],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsDimension]: {
        fieldComponent        : FieldDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsGlassDimension]: {
        fieldComponent        : FieldDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsGlassDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsElectric]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsElectric],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsDisposition]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsDisposition],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsDwelling]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsDwelling],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsProtection]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsProtection],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsManeuver]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsManeuver],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsLight]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsLight],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.WindowBlindsPose]: {
        fieldComponent        : FieldOptionalRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.WindowBlindsPose],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.MirrorFrameMaterial]: {
        fieldComponent        : FieldOptionalMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.MirrorFrameMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClosetDoorSens]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClosetDoorSens],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ClosetDoorFrameMaterial]: {
        fieldComponent        : FieldOptionalMaterialChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ClosetDoorFrameMaterial],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FencingDestination]: {
        fieldComponent        : FieldMultiSelectorChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FencingDestination],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FencingPose]: {
        fieldComponent        : FieldOptionalRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FencingPose],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.FenceGateDimension]: {
        fieldComponent        : FieldOptionalDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.FenceGateDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalShape]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalShapeDimension]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalShapeDimension],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalOpening]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalOpening],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalMotorization]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalMotorization],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalFilling]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalFilling],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalGate]: {
        fieldComponent        : FieldOptionalDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalGate],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.PortalLaying]: {
        fieldComponent        : FieldBooleanChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.PortalLaying],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenHomeAppliance]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenHomeAppliance],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenProjectType]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenProjectType],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenFurniture]: {
        fieldComponent        : FieldShapeQuantitiesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenFurniture],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenHandle]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenHandle],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenShape]: {
        fieldComponent        : FieldShapeDimensionChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenShape],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenLayout]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenLayout],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Finishing]: {
        fieldComponent        : FieldRadioListChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Finishing],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenStyle]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenStyle],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ProjectInformation]: {
        fieldComponent        : FieldProjectInformationChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ProjectInformation],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.UploadFiles]: {
        fieldComponent        : FieldUploadFilesChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.UploadFiles],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.Budget]: {
        fieldComponent        : FieldBudgetChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.Budget],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.ApplianceLevel]: {
        fieldComponent        : FieldApplianceLevelChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.ApplianceLevel],
        fieldExclusionsGetter : undefined,
    },
    [IFormFieldKey.KitchenMaterialShade]: {
        fieldComponent        : FieldShapeChat,
        fieldValidate         : formFieldKeysToValidations[IFormFieldKey.KitchenMaterialShade],
        fieldExclusionsGetter : undefined,
    },
};

export default config;
